import { Link } from "react-router-dom";

const RED = "#CC2222";
const CHARCOAL = "#1A1A1A";
const BODY = "#2C2825";
const LIGHT = "#F5F5F5";

const PRODUCTS = [
  {
    slug: "deluxe-pomade",
    name: "Deluxe Pomade",
    category: "Styling",
    tagline: "Strong Hold · High Shine · Water Soluble",
    price: "$19.00 USD",
    description: "Premium pomade delivering strong hold and high shine for classic and modern hairstyles. Infused with argan oil.",
    image: "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/tqoq64xy_Deluxe%20Pomade.jpg",
    buyUrl: "https://square.link/u/yKDiLMdA",
  },
  {
    slug: "texture-paste",
    name: "Texture Paste",
    category: "Styling",
    tagline: "Strong Hold · Matte Finish · Easy to Restyle",
    price: "$19.00 USD",
    description: "Versatile texture paste with strong hold and a natural matte finish. Easy to restyle throughout the day. Infused with argan oil.",
    image: "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/5jw0awsj_Texture%20paste.jpg",
    buyUrl: "https://square.link/u/vBeN7RXj",
  },
  {
    slug: "little-matte-creme",
    name: "Little Matte Creme",
    category: "Styling",
    tagline: "Light Hold · Matte Finish · Natural Look",
    price: "$19.00 USD",
    description: "Lightweight matte cream that gives you a natural look with light hold. Perfect for everyday styling. Infused with argan oil.",
    image: "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/gs7abb8d_Little%20Man%20Cream.jpg",
    buyUrl: "https://square.link/u/KkyDs8UV",
  },
];

function ProductCard({ p }) {
  return (
    <div
      className="bg-white border border-[#E0E0E0] flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(0,0,0,0.18)]"
      style={{ borderBottom: `2px solid ${RED}` }}
      data-testid={`product-card-${p.slug}`}
    >
      <div className="w-full aspect-square overflow-hidden flex items-center justify-center" style={{ background: LIGHT }}>
        <img src={p.image} alt={p.name} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="flex-1 flex flex-col p-6 sm:p-7">
        <div className="text-[10px] tracking-[0.35em] uppercase font-semibold" style={{ color: RED }}>{p.category}</div>
        <h3 className="mt-3 text-2xl sm:text-3xl" style={{ color: CHARCOAL, fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>{p.name}</h3>
        <div className="mt-2 text-[12px] tracking-[0.05em] uppercase" style={{ color: BODY, opacity: 0.75 }}>{p.tagline}</div>
        <div className="mt-4 text-xl" style={{ color: RED, fontWeight: 600 }}>{p.price}</div>
        <p className="mt-4 text-sm leading-relaxed flex-1" style={{ color: BODY }}>{p.description}</p>
        <a
          href={p.buyUrl}
          target="_blank"
          rel="noreferrer"
          className="mt-7 w-full text-center px-6 py-4 text-[11px] tracking-[0.3em] uppercase text-white bg-[#CC2222] hover:bg-[#a81b1b] transition-colors"
          data-testid={`product-buy-${p.slug}`}
        >
          Buy Now
        </a>
      </div>
    </div>
  );
}

export default function Products() {
  return (
    <div data-testid="products-page" style={{ background: "#FFFFFF" }}>
      {/* Header */}
      <section className="py-20 sm:py-24" style={{ background: LIGHT }} data-testid="products-header">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10" style={{ background: RED }} />
            <span className="text-[11px] tracking-[0.4em] uppercase font-semibold" style={{ color: RED }}>Our Products</span>
            <span className="h-px w-10" style={{ background: RED }} />
          </div>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl leading-[1.05]" style={{ color: CHARCOAL, fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
            AXYAM Hair Care
          </h1>
          <p className="mt-6 max-w-2xl mx-auto text-base sm:text-lg" style={{ color: BODY }}>
            Professional grade products crafted to deliver salon-quality results at home.
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="py-16 sm:py-20" data-testid="products-grid-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {PRODUCTS.map((p) => <ProductCard key={p.slug} p={p} />)}
          </div>
        </div>
      </section>

      {/* Trust / contact strip */}
      <section className="pb-24" data-testid="products-trust-strip">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
          <div className="py-5 px-6 text-sm" style={{ background: LIGHT, color: BODY, border: "1px solid #E0E0E0" }}>
            Secure payment by Square — Shipping available across the USA
          </div>
          <div className="mt-6">
            <Link to="/contact" className="text-[11px] tracking-[0.3em] uppercase font-semibold hover:opacity-80 transition-opacity" style={{ color: RED }} data-testid="products-contact-link">
              Questions about our products? Contact us →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
